import styled from "styled-components";


export const ContentInfos = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
export const ContentButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
`;
